module.exports = __webpack_public_path__ + "img/Domain_SBES.dd3906be.png";